/*! npm.im/visibility-change-ponyfill */
'use strict';

/**
 * ON CHANGE
 * Track the value of anything (through a function)
 * and call the callback when it does.
 * It doesn't do deep comparisons.
 * It doesn't verify automatically,
 * you decide when it may be necessary with verifyChange()
 *

EXAMPLE:

const verifyChange = onChange(
	() => valueToTrack,
	(newValue, oldValue) => console.log(oldValue, 'changed to', newValue)
);

verifyChange();
setInterval(verifyChange, 100)

*/
function onChange (getter, callback) {
	var lastValue = getter();
	var currentValue;
	return function () {
		currentValue = getter();
		if (currentValue !== lastValue) {
			callback(currentValue, lastValue);
			lastValue = currentValue;
		}
	};
}

var handlers = [];
var isBeingTracked;

var verifyVisibilityChange = onChange(
	function () { return document.hidden; },
	function () {
		handlers.forEach(setTimeout); // With setTimeout errors won't stop the loop
	}
);

function maybeStartTracking() {
	if (!isBeingTracked) {
		isBeingTracked = setInterval(verifyVisibilityChange, 333);
		document.addEventListener('visibilitychange', verifyVisibilityChange);
	}
}

function maybeStopTracking() {
	if (handlers.length === 0) {
		isBeingTracked = clearInterval(isBeingTracked);
		document.removeEventListener('visibilitychange', verifyVisibilityChange);
	}
}

function onVisibilityChange(handler) {
	handlers.push(handler);
	maybeStartTracking();
}

onVisibilityChange.remove = function (handler) {
	handlers = handlers.filter(function (fn) { return fn !== handler; });
	maybeStopTracking();
};

onVisibilityChange.removeAll = function () {
	handlers.length = 0;
	maybeStopTracking();
};

module.exports = onVisibilityChange;